import { CheckListFilter } from '@app/modules/table/classes/column-filters/check-list/check-list-filter.class';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class TypeColumn extends Column {
    title = 'table.transactions.type';
    property = 'type';
    type = CellDisplay.string;
    sortable = true;
    filters = [
        new CheckListFilter('type', [
            { label: 'table.transactions.debit', value: 'Debit' },
            { label: 'table.transactions.credit', value: 'Credit' },
        ]),
    ];
}
